import { useState, useEffect } from "react";
import api from "../../../utils/api";
import { formatDateForAPI } from "../utils/orderUtils";
import { useRestaurantConfig } from "../../../utils/restaurantConfig";
import { dateFromYmd, getRestaurantTodayDate } from "../../../utils/dateTimeUtils";

export const useProductReport = (qrFeatureEnabled = true) => {
  const { timezone } = useRestaurantConfig();
  const today = dateFromYmd(getRestaurantTodayDate(timezone));

  const [products, setProducts] = useState([]);
  const [totalProducts, setTotalProducts] = useState(0);
  const [totalQty, setTotalQty] = useState(0);
  const [totalSales, setTotalSales] = useState(0);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [showAllDates, setShowAllDates] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchProductReport = async () => {
      setIsLoading(true);
      try {
        let endpoint = "/orders/product-report";

        if (!showAllDates && fromDate && toDate) {
          endpoint = `/orders/product-report?startDate=${formatDateForAPI(
            fromDate,
          )}&endDate=${formatDateForAPI(toDate)}`;
        }

        const res = await api.get(endpoint);
        setProducts(res.data?.products || []);
        setTotalProducts(res.data?.totalProducts || 0);
        setTotalQty(res.data?.totalQty || 0);
        setTotalSales(res.data?.totalSales || 0);
      } catch (err) {
        console.error("Fetch product report error:", err);
        setProducts([]);
        setTotalProducts(0);
        setTotalQty(0);
        setTotalSales(0);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProductReport();
  }, [fromDate, toDate, showAllDates, qrFeatureEnabled]);

  return {
    products,
    totalProducts,
    totalQty,
    totalSales,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    showAllDates,
    setShowAllDates,
    isLoading,
  };
};
